module.exports = __webpack_public_path__ + "img/instagram.6c90375a.svg";